export const PATIENT_FEEDBACK = "/patient/v1/";
